import { SupplyTransactionStatusEnum, UpdateSupplyOrderOnSaleOrderCancelSupplyOrdersActionsEnum } from '@/types'
import * as Yup from 'yup'

export const schemaStep1 = (t: (key: string) => string) => ({
  status: Yup.string().required(t('requiredMessage')),
  cancellationReason: Yup.object()
    .shape({
      reason: Yup.string().required(t('requiredMessage')),
    })
    .required(t('requiredMessage')),
})

export const schema = (t: (key: string) => string) => ({
  status: Yup.string().required(t('requiredMessage')),
  cancellationReason: Yup.object().shape({
    reason: Yup.string().required(t('requiredMessage')),
  }),
  shipments: Yup.array().of(
    Yup.object().shape({
      status: Yup.string().required(t('requiredMessage')),
      uuid: Yup.string().required(t('requiredMessage')),
    }),
  ),
  payments: Yup.array().of(
    Yup.object().shape({
      status: Yup.string().required(t('requiredMessage')),
      uuid: Yup.string().required(t('requiredMessage')),
    }),
  ),
  invoices: Yup.array().of(
    Yup.object().shape({
      status: Yup.string().required(t('requiredMessage')),
      uuid: Yup.string().required(t('requiredMessage')),
    }),
  ),
})

export const schemaStep3 = (t: (key: string) => string) => ({
  supplyOrders: Yup.array().of(
    Yup.object().shape({
      action: Yup.string().required(t('requiredMessage')),
      uuid: Yup.string().required(t('requiredMessage')),
    }),
  ),
})

export const enabledUpdateSupplyOrdersActions: Record<keyof typeof SupplyTransactionStatusEnum, Array<keyof typeof UpdateSupplyOrderOnSaleOrderCancelSupplyOrdersActionsEnum>> = {
  'paid': ['credit_balance', 'money_refund', 'keep_inventory'],
  'pending': ['keep_inventory', 'cancel_all'],
  'cancelled': []
}